<ng-container *ngIf="permissions.canGetVendor || permissions.canGetConsultation || permissions.canGetSupport">
    <button class="live-chat-button icon-md-2" type="button" *ngIf="floatingButton; else dropdownButton" [matMenuTriggerFor]="chatMenu" [ngClass]="{'mobile-position': deviceDetector.isMobile()}" [dir]="direction.isRTL() ? 'rtl' : 'ltr'">
        <div class="notification" [ngClass]="{'d-none': newMessages == 0}">{{newMessages}}</div>
        <div class="icon">
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="chat_elipses"></mat-icon>
            <!-- <img src="assets/svg/chat_elipses.svg" style="margin-top: -0.25rem;"> -->
        </div>
    </button>

    <ng-template #dropdownButton>
        <button class="btn menu-btn" type="button" [matMenuTriggerFor]="chatMenu">
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="chat_elipses" [inline]="true"></mat-icon>
        </button>
    </ng-template>

    <mat-menu #chatMenu="matMenu" yPosition="above" class="chat-menu-container" [overlapTrigger]="true">
        <button mat-menu-item [disabled]="!companyData" (click)="openChat('vendor');" *ngIf="permissions.canGetVendor">
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="chat-info"></mat-icon>
            <span>{{"chat_with_vendor"|translate}}</span>
        </button>
        <button mat-menu-item (click)="openChat('consult');" *ngIf="permissions.canGetConsultation">
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="consult_us"></mat-icon>
            <span>{{"consult_us"|translate}}</span>
        </button>
        <button mat-menu-item (click)="openChat('support');" *ngIf="permissions.canGetSupport && siteService.features?.chat">
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="chat_with_us"></mat-icon>
            <span>{{"chat_with_us"|translate}}</span>
        </button>
    </mat-menu>
</ng-container>
